import React from 'react';

export default function PageHero({ eyebrow, title, stats = [], children }) {
  const hasStats = Array.isArray(stats) && stats.length > 0;

  return (
    <section className="page-hero">
      <div className="page-hero-inner">
        <div className="page-hero-copy">
          <h1>{title}</h1>
          {eyebrow && <span className="page-hero-eyebrow">{eyebrow}</span>}
        </div>
        {(hasStats || children) && (
          <div className="page-hero-side">
            {hasStats && (
              <div className="page-hero-stats">
                {stats.map((stat) => (
                  <div className="page-hero-stat" key={stat.label}>
                    <span>{stat.value}</span>
                    <em>{stat.label}</em>
                  </div>
                ))}
              </div>
            )}
            {children}
          </div>
        )}
      </div>
    </section>
  );
}
